import { styled } from 'styles';

export const StyledHighlight = styled.span`
  background-color: ${({ theme }) => theme.highlight.background};
  border-radius: ${({ theme }) => theme.radius.tiny};
  color: ${({ theme }) => theme.highlight.color};
  line-height: 1.2em;
`;

StyledHighlight.displayName = 'Highlight';
